import { render, staticRenderFns } from "./MunicipalityPanel.vue?vue&type=template&id=370c873c&"
import script from "./MunicipalityPanel.vue?vue&type=script&lang=js&"
export * from "./MunicipalityPanel.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalityPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports